import React, { useState, useEffect } from 'react';
import { CSSTransition } from 'react-transition-group';
import './style.css';

const TRANSITION_TIMEOUT = 1200;

const MessageRotator = ({ messages, interval, hidden }) => {
  const [currentIndex, setCurrentIndex] = useState(Math.floor(Math.random() * messages.length));

  const getRandomIndex = (currentIndex, arrayLength) => {
    const newIndex = (currentIndex + Math.floor(Math.random() * (arrayLength - 1) + 1)) % arrayLength;
    return newIndex;
  };

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) => getRandomIndex(prevIndex, messages.length));
    }, interval + TRANSITION_TIMEOUT);

    return () => {
      clearInterval(timer);
    };
  }, [currentIndex, interval, messages.length]);

  return (
    <div className={`message-rotator ${hidden ? 'message-rotator-hidden' : ''}`}>
      {messages.map((message, index) => (
        <CSSTransition
          key={index}
          in={currentIndex === index}
          timeout={2000}
          classNames='message'
          unmountOnExit
        >
          <div className='message'>
            <span>{message}</span>
          </div>
        </CSSTransition>
      ))}
    </div>
  );
};

export default MessageRotator;
